/**
 * Sprache des **kundengerichteten** Teils des Statusberichts.
 *
 * Entscheidung (Fachkonzept §13.1, 2026-08-05): Die Sprache des Berichts hängt
 * am **Kunden**, nicht an der Oberflächensprache des Absenders. Ein
 * Bereichsleiter, der die Oberfläche für sich auf Englisch stellt, darf damit
 * nicht plötzlich einem deutschen Kunden einen englischen Bericht schicken —
 * und umgekehrt.
 *
 * Ein Sprachmerkmal am Kunden gibt es im Datenmodell heute nicht, und alle
 * Servicekunden der abgelösten App wurden auf Deutsch bedient. Der
 * kundengerichtete Teil ist deshalb **fest deutsch**; die Erweiterung ist eine
 * Einstellung je Beauftragung (`docs/OFFENE-PUNKTE.md`), an der genau diese
 * beiden Konstanten hängen.
 *
 * Was NICHT hierher gehört: alles, was der Bearbeiter sieht — Knöpfe,
 * Beschriftungen, Hinweise, die Monatsauswahl. Das folgt weiter der
 * Oberflächensprache.
 */
export const REPORT_LANGUAGE = "de";

/** Zahlen- und Datumsformat des Berichts — dieselbe Entscheidung. */
export const REPORT_LOCALE = "de-DE";
